import { useEffect } from "react";

import { recordFirstAppOpen } from "@/lib/activationFunnel";
import { trackActiveSession } from "@/lib/analytics";

/** Records first app open + active-session cohort markers once per device. */
export function ActivationTracker() {
  useEffect(() => {
    recordFirstAppOpen();
    trackActiveSession();
  }, []);

  return null;
}
